
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class CrystallineLatticeEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
         const spacing = (150 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;
        const curTime = time * config.parallaxSpeed;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const drawCell = (x: number, y: number, s: number) => {
            const rot = this.pseudoRandom(x + y) * Math.PI + curTime * 0.1;
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rot);
            ctx.beginPath();
            ctx.rect(-s/2, -s/2, s, s);
            ctx.moveTo(-s/2, -s/2);
            ctx.lineTo(s/2, s/2);
            ctx.moveTo(s/2, -s/2);
            ctx.lineTo(-s/2, s/2);
            ctx.stroke();
            ctx.restore();
        };

        const draw = () => {
            for (let x = x1; x <= x2; x += spacing) {
                for (let y = y1; y <= y2; y += spacing) {
                    drawCell(x, y, spacing * 0.6 * scale);
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
